import React from "react";
import { EasyZoomOnMove } from "easy-magnify";

const ZOOM_IMAGE_WIDTH = 500;
const ZOOM_IMAGE_HEIGHT = 500;

export interface IZoomableImage {
  imageUrl: string;
}

export const ZoomableImage: React.FC<IZoomableImage> = ({ imageUrl }) => {
  return (
    <EasyZoomOnMove
      mainImage={{
        src: imageUrl,
        width: ZOOM_IMAGE_WIDTH,
        height: ZOOM_IMAGE_HEIGHT,
      }}
      zoomImage={{
        src: imageUrl,
      }}
    />
  );
};
